import { EventShared, ScopeShared } from "@/componentShare/constant"
import SharedStateBusInstance from "@/componentShare/SharedStateBus"
import { getDataRoleAccount } from "@/controllers/gridManager/accountsManager/accountManager"
import { ResponseSuccess } from "@/controllers/gridManager/followerTransManager/followerTransManager"
import { appStartupComplete, incrementRegisCount, initApp, resetDataNotificationSocket, setConfigCos, setCosInfo, setDataNotificationSocket, setIndustryData, setLanguage, setMsgSocketRegister, setSaveVerify, setStateLoading, setStatusRegisterMF, setStatusSocket, setTheme } from "@/stores/dataStore/reduxStore/appSlice/appSlice"
import { getSnapShotIndexes, getSnapShotIndexesInfo } from "@/stores/dataStore/reduxStore/indexSlice"
import { RootState, store } from "@/stores/dataStore/reduxStore/store"
import ToastUtil from "@/views/components/Toast/Toast"
import i18next from "i18next"
const dispatch = store.dispatch

export type T_ACTION_BY_SOCKET = 'CONFIRM' | 'REJECT' | 'NONE'

export const EVENT_TYPE = {
    REGIS: "REGIS",
    TRANS: "TRANS",

    // bad
    FL_INVEST: "FL_INVEST",
    TRANSFERCI: "TRANSFERCI",
}

export const TRANS_TYPE = {
    FL_INVEST: "FL_INVEST",
    TRANSFERCI: "TRANSFERCI",
}

export const StoreMarketIndexes = (state: RootState) => state.indexes.marketIndexes
export const StoreMarketIndexesInfo = (state: RootState) => state.indexes.marketIndexInfo

export const getSnapShotIndexesInfoAction = () => {
    return dispatch(getSnapShotIndexesInfo())
}

export const getSnapShotIndexesAction = () => {
    return dispatch(getSnapShotIndexes())
}

export const setLanguageAction = (language: string) => {
    return dispatch(setLanguage({ language }))
};

export const setThemeAction = (theme: string) => {
    return dispatch(setTheme({ theme }))
};

export const initializeAppAction = (initObject: any) => {
    return dispatch(initApp(initObject))
};

export const setCosInfoAction = (objData: any) => {
    return dispatch(setCosInfo({ info: objData }))
};

export const setConfigCosAction = (objData: any) => {
    return dispatch(setConfigCos({ config: objData }))
};

export const setIndustryDataAction = (data: any) => {
    return dispatch(setIndustryData({ industry: data }))
};

export const setStateLoadingAction = (data: boolean) => {
    return dispatch(setStateLoading({ state: data }))
};

export const setStatusRegisterMFAction = (data: string | null) => {
    return dispatch(setStatusRegisterMF({ status: data }))
};

export const setMsgSocketRegisterAction = (data: string | null) => {
    return dispatch(setMsgSocketRegister({ msg: data }))
};

export const setAppStartupComplete = () => {
    return dispatch(appStartupComplete())
};

export const onSocketAccountAction = (accountId: string, eventType: string, packageMsg: any[]) => {

    if (packageMsg && packageMsg.length !== 0) {
        const ACTION: T_ACTION_BY_SOCKET = packageMsg?.[0]?.ACTION
        const ERRMSG = packageMsg[0]?.ERRMSG
        const TRANSTYPE = packageMsg[0]?.TRANSTYPE ?? null
        console.log('ha_check_onSocketAccountAction', eventType, ACTION)

        if (eventType === EVENT_TYPE.REGIS) {
            if (ACTION === 'CONFIRM') {
                fetchRoleAccount()
                // sync accounts host
                SharedStateBusInstance.emit(EventShared.HOST_RELOAD_USER_INFO, ScopeShared.MF, {})
                ToastUtil.success(i18next.t('msgApi.notificationSuccess.register'))
            } else {
                ERRMSG && ToastUtil.error(i18next.t("msgApi.error.submitRegisterFollower"), ERRMSG)
            }
            setTimeout(() => {
                setMsgSocketRegisterAction(null)
                setStatusRegisterMFAction(null)
            }, 3000);
            (null)

            return dispatch(incrementRegisCount({ accountId, ACTION, ERRMSG }))
        }

        // if (eventType === EVENT_TYPE.TRANS) {
        if (eventType === EVENT_TYPE.FL_INVEST) {
            if (TRANSTYPE === TRANS_TYPE.FL_INVEST) {
                if (ACTION === 'CONFIRM') {
                    ToastUtil.success(i18next.t('msgApi.notificationSuccess.copyMaser'))
                } else {
                    ERRMSG && ToastUtil.error(i18next.t("msgApi.error.submitCopyMaster"), ERRMSG)
                }
                setTimeout(() => {
                    resetDataNotificationSocketAction()
                }, 3000);
                return dispatch(setDataNotificationSocket({ status: ACTION, msg: ACTION === 'REJECT' ? ERRMSG : null, feature: TRANSTYPE }))
            }
        }

        if (eventType === EVENT_TYPE.TRANSFERCI) {
            if (TRANSTYPE === TRANS_TYPE.TRANSFERCI) {
                if (ACTION === 'CONFIRM') {
                    ToastUtil.success(i18next.t('msgApi.notificationSuccess.withDraw'))
                } else {
                    ERRMSG && ToastUtil.error(i18next.t("msgApi.error.submitWithdrawCash"), ERRMSG)
                }
                setTimeout(() => {
                    resetDataNotificationSocketAction()
                }, 3000);
                return dispatch(setDataNotificationSocket({ status: ACTION, msg: ACTION === 'REJECT' ? ERRMSG : null, feature: TRANSTYPE }))
            }
        }

    }
};

export const resetDataNotificationSocketAction = async () => {
    return dispatch(resetDataNotificationSocket())
};

export const onSetStatusSocket = (socketStatus: string) => {
    return dispatch(setStatusSocket({ status: socketStatus }))
};


export const fetchRoleAccount = async () => {
    const custodycd = store.getState()?.app?.userInfo?.custodycd
    try {
        await getDataRoleAccount(custodycd).then((rs: ResponseSuccess) => {
            const { isSuccess, data } = rs
            if (isSuccess) {
                setCosInfoAction(data)
            }
        })
    } catch (error) {
    } finally {
    }
};

export const setSaveVerifyAction = (status: boolean) => {
    return dispatch(setSaveVerify({ status }))
};